<img src="/assets/svg/logo-white.svg" class="logo" />
<h2>{{ 'error_page_header' | translate }}</h2>
<p>{{ 'error_page_message' | translate }}</p>
<a (click)="goToHomepage()">{{ 'error_homepage_link' | translate }}</a>
